<template>
    <div class="your-details">
        <h1 class="your-details--title">{{$t('REGISTER_YOUR_DETAILS_TITLE')}}</h1>
        <p class="your-details--text">{{$t('REGISTER_YOUR_DETAILS_TEXT')}}</p>
        <div class="your-details--input">
        <!--First Name-->
            <input-field
                class="your-details--input--first"
                id="first_name"
                :mandatory="true"
                v-model="firstName"
                autocomplete="given-name"
                :is-valid="!errorHandler.has('first_name')"
                :message="errorHandler.get('first_name')"
                :placeholder="$t('ACCOUNT_FORM_FIRST_NAME')"/>

            <!--Last Name-->
            <input-field
                class="your-details--input--last"
                id="last_name"
                :mandatory="true"
                v-model="lastName"
                autocomplete="family-name"
                :is-valid="!errorHandler.has('last_name')"
                :message="errorHandler.get('last_name')"
                :placeholder="$t('ACCOUNT_FORM_LAST_NAME')"/>
        </div>

        <email-address-field
            class="your-details--input--email contentsquare_sensitive_data"
            :should-validate="true"
            id="email"
            :placeholder="$t('REGISTER_PLACEHOLDER_EMAIL')"
            :showLabel="false"
            :mandatory="true"
            :is-valid="!errorHandler.has('email')"
            :message="errorHandler.get('email')"
            :value="email"
            v-model="email"/>
        <password-field
            :require-strong-password="true"
            class="your-details--input--passsword contentsquare_sensitive_data"
            id="password"
            :placeholder="$t('REGISTER_PLACEHOLDER_PASSWORD')"
            :showLabel="false"
            :noPadding="true"
            :mandatory="true"
            :is-valid="!errorHandler.has('password')"
            :message="errorHandler.get('password')"
            :key="`p-${password}`"
            v-model="password"/>

        <checkbox
            v-model="optInMarketing"
            :smallFont="true"
            class="your-details--input--marketingOptIn">
            {{ $t('ACCOUNT_FORM_I_WOULD_LIKE') }}
        </checkbox>

        <checkbox
            v-model="optInThirdPartyMarketing"
            :smallFont="true"
            class="your-details--input--marketingOptIn">
            {{ $t('ACCOUNT_FORM_THIRD_PARTY_OPT') }}
        </checkbox>

        <div class="your-details--next-button">
            <submit-button
                @click="submitCurrentStep"
                :processing="isFormProcessing"
                color="green">
                {{ $t('ACCOUNT_FORM_NEXT_STEP') }}
            </submit-button>
        </div>
        <alt-trust-pilot class="your-details--trust-pilot"/>
        <simple-footer />
    </div>
</template>

<script>
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import RegistrationService from '@/services/users/RegistrationService';
import IncompleteRegistrationService from '@/services/users/incompleteRegistrationService/IncompleteRegistrationService';
import InputField from '@/components/forms/fields/InputField';
import EmailAddressField from '@/components/forms/fields/EmailAddressField';
import PasswordField from '@/components/forms/fields/PasswordField';
import Checkbox from '@/components/forms/fields/Checkbox';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import SimpleFooter from '@/components/structure/SimpleFooter';
import AltTrustPilot from '@/components/forms/fields/AltTrustPilot';

export default {
    name: 'YourDetails',
    components: {
        InputField,
        EmailAddressField,
        PasswordField,
        Checkbox,
        SubmitButton,
        AltTrustPilot,
        SimpleFooter,
    },
    data: () => {
        return {
            isFormProcessing: false,
            errorHandler: new ErrorResponseHandler(),
            email: '',
        };
    },
    mounted() {
        this.email = this.$store.getters['register/getEmail'];
    },
    computed: {
        firstName: {
            get() {
                return this.$store.getters['register/getFirstName'];
            },
            set(value) {
                this.$store.commit('register/setFirstName', value);
            },
        },
        lastName: {
            get() {
                return this.$store.getters['register/getLastName'];
            },
            set(value) {
                this.$store.commit('register/setLastName', value);
            },
        },
        password: {
            get() {
                return this.$store.getters['register/getPassword'];
            },
            set(value) {
                this.$store.commit('register/setPassword', value);
            },
        },
        optInMarketing: {
            get() {
                return this.$store.getters['register/getOptInMarketing'];
            },
            set(value) {
                this.$store.commit('register/setOptInMarketing', value);
            },
        },
        optInThirdPartyMarketing: {
            get() {
                return this.$store.getters['register/getOptInThirdPartyMarketing'];
            },
            set(value) {
                this.$store.commit('register/setOptInThirdPartyMarketing', value);
            },
        },
    },
    methods: {
        submitCurrentStep() {
            this.errorHandler.reset();
            this.isFormProcessing = true;
            this.$store.commit('register/setEmail', this.email);

            setTimeout(() => (new IncompleteRegistrationService()).updateOrCreate(), 0);
            RegistrationService.validateIntroductions()
                .then(() => {
                    this.isFormProcessing = false;
                    this.$store.dispatch('cookies/mountRokt');
                    this.$router.push({ name: 'register.payment-details' });
                })
                .catch(error => {
                    this.errorHandler.setResponse(error.response.data);
                    this.isFormProcessing = false;
                    this.$scrollTo(`#${Object.keys(this.errorHandler.response.errors)[0]}`, {
                        offset: -100,
                    });
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.your-details {
    margin: 30px auto;

    &--title {
        font-size: 25px;
        line-height: 130%;
        color: #262323;
        margin: 0;
    }
    &--text {
        font-size: 16px;
        line-height: 140%;
        color: #262323;
        margin: 16px 0;
    }
    &--input {
        width: 100%;
        margin: 20px 0;
        &--first, &--last, &--email {
            padding: 0;
            ::placeholder {
                color: #b3b3b3;
            }
        }
        &--email {
            margin-top: 50px;
            width: 100%;
            padding: 0;
        }
    }
    &--next-button {
        width: 80%;
        margin: 20px auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &--trust-pilot {
        margin-top: 50px;
        width: 100%;
    }
}
</style>
